import React from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import {FaInfoCircle} from "react-icons/fa";
import {t} from "../../../shared-services/translate";
import styled from "styled-components";
import currentTheme from "../../../react-themes/theme";
import {parsePrice} from "../../products/useProductPrice";

const theme = currentTheme();

const AdjustmentListItem = (props) => {
  const {adjustment, mov, onClick, className = "", style} = props;
  const {currency} = useSelector(state => state.session);
  const codeClass = adjustment.code?.slice(1);

  return (
    <LiElementSummary
      onClick={onClick}
      key={adjustment.label}
      className={`
        flex
        flex-direction-column
        margin-bottom-10
        font-family-alata
        ${adjustment.additional_info ? "cursor-pointer" : ""}
        ${adjustment.code?.slice(1)} ${mov ? "mov-highlight" : ""}
        ${className}
      `}
      style={style}
    >
      <div className={"flex justify-content-space-between full-width"}>
        <span>
          {adjustment.label}
          {adjustment.additional_info &&
            <FaInfoCircle className={"text-color-green margin-left-5"} style={{verticalAlign: "middle"}} />
          }</span>

        <span className="flex-shrink-0">
          {currency} {parsePrice(adjustment.amount)}
        </span>
      </div>
      {codeClass === "item_total" && mov &&
        <span className={"mov-reminder"}>
          {t("cart.minimum_mov", {mov: parsePrice(mov)})}
        </span>
      }
    </LiElementSummary>
  );
};

export default AdjustmentListItem;

const LiElementSummary = styled.li.attrs(props => ({
  className: props.className
}))`
  padding: 0 12px;
  &.item_total {
    &.mov-highlight {
      border-radius: 6px;
      padding: 12px;
      background-color: #F2F2F2;
    }
    
    .mov-reminder {
      font-size: 90%;
      color: ${theme.colors.muteTextColor};
    }
  }
`;
